import { metersPerNauticalMile } from "./constants";
import type { Cargo, Drop } from "./model";

const defaultCargo: Cargo[] = [
  {
    name: "Airframe",
    weight: 493.5,
    location: 49.35,
  },
  {
    name: "Front bulkhead steel",
    weight: 176,
    location: 1,
  },
  { name: "Front skidboard tabs", weight: 8, location: 12 },
  { name: "Rear skidboard tabs", weight: 8, location: 84 },
  { name: "Cargo separator panels", weight: 10.5, location: 0 },
  { name: "Heavy skidplate delta", weight: 21.5, location: 0.125 },
  { name: "Skidplate forward", weight: 32, location: -5.5 },
];

const allCargo = ({ emptyWeight, cargo }: Drop) => [
  ...defaultCargo.map(_ =>
    _.name === "Airframe" ? { ..._, weight: emptyWeight } : _,
  ),
  ...cargo,
];

export const calculateWeight = (drop: Drop) =>
  allCargo(drop).reduce((total, cargo) => total + cargo.weight, 0);

const calculateMoment = (drop: Drop) =>
  allCargo(drop).reduce(
    (total, cargo) => total + cargo.weight * cargo.location,
    0,
  );

export const calculateCenterOfGravity = (drop: Drop) =>
  calculateMoment(drop) / calculateWeight(drop);

export const calculateMinCenterOfGravity = (drop: Drop) => {
  const weight = calculateWeight(drop);
  return -0.000012 * weight ** 2 + 0.0576 * weight - 25.5396;
};

export const calculateMaxCenterOfGravity = (drop: Drop) =>
  0.0012 * calculateWeight(drop) + 35.3376;

const indicatedDropSpeed = {
  a: -0.0000185,
  b: 0.0882,
  c: 34.46,
};

export const calculateBestGlideSpeed = (drop: Drop) => {
  const { a, b, c } = indicatedDropSpeed;
  const weight = calculateWeight(drop);
  return ((a * weight ** 2 + b * weight + c) * metersPerNauticalMile) / 3600;
};
